import { useLanguagePreferenceSync } from '../hooks/useLanguagePreference'

export function LanguagePreferenceSync() {
    useLanguagePreferenceSync()
    return null
}
